import React, { useState, useEffect, useCallback } from 'react';

let _addToast = null;

export const toast = {
  success: (msg) => _addToast && _addToast(msg, 'success'),
  error:   (msg) => _addToast && _addToast(msg, 'error'),
  info:    (msg) => _addToast && _addToast(msg, 'info'),
  warning: (msg) => _addToast && _addToast(msg, 'warning'),
};

export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((msg, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4000);
  }, []);

  useEffect(() => { _addToast = addToast; return () => { _addToast = null; }; }, [addToast]);

  const icons = { success: '✓', error: '✕', info: 'ℹ', warning: '⚠' };
  const colors = {
    success: { bg: '#D1FAE5', border: '#34D399', icon: '#065F46', text: '#065F46' },
    error:   { bg: '#FEE2E2', border: '#F87171', icon: '#991B1B', text: '#991B1B' },
    info:    { bg: '#DBEAFE', border: '#60A5FA', icon: '#1E40AF', text: '#1E40AF' },
    warning: { bg: '#FEF3C7', border: '#FBBF24', icon: '#92400E', text: '#92400E' },
  };

  if (!toasts.length) return null;

  return (
    <div style={{ position:'fixed', top:'20px', right:'20px', zIndex:99999, display:'flex', flexDirection:'column', gap:'10px', maxWidth:'380px' }}>
      {toasts.map(t => {
        const c = colors[t.type] || colors.info;
        return (
          <div key={t.id} style={{ background: c.bg, border: '1px solid ' + c.border, borderRadius: '10px', padding: '14px 16px', display: 'flex', alignItems: 'flex-start', gap: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)', animation: 'slideIn 0.25s ease' }}>
            <div style={{ width:'22px', height:'22px', borderRadius:'50%', background: c.border, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'13px', fontWeight:'700', flexShrink:0 }}>
              {icons[t.type]}
            </div>
            <div style={{ fontSize:'13px', color: c.text, lineHeight:'1.5', flex:1 }}>{t.msg}</div>
            <button onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
              style={{ background:'none', border:'none', color: c.text, cursor:'pointer', fontSize:'16px', padding:'0', opacity:0.6, flexShrink:0 }}>×</button>
          </div>
        );
      })}
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </div>
  );
};
